import { NgModule } from '@angular/core';
import { FilterTagComponent } from './filter-tag.component';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [FilterTagComponent],
  exports: [FilterTagComponent],
  entryComponents: [FilterTagComponent],
  imports: [CommonModule, AngularSvgIconModule]
})
export class FilterTagModule {}

export { FilterTagComponent };

export * from './filter-tag.types';
